import Vue from 'vue';
import Vuex from 'vuex';
import lodash from 'lodash';
import $http from '../assets/js/request.js';
import Cookies from 'js-cookie';
//挂载Vuex
Vue.use(Vuex);

//创建VueX对象
const store = new Vuex.Store({
	// 共享状态（即变量）
	state: {
		// 缓存组件页面
		catch_components: [],
		// 全局请求后台URL
		// baseURL: 'http://localhost:9999',
		// 当前选中的菜单 - 默认选择首页
		activePath: 'orderList',
		// 菜单项 - 默认包含首页
		tabList: [],
		menuList: [
			{
				id: 14,
				path: 'cart',
				name: 'Cart',
				label: '新订单'
			},
			// {
			// 	id: 1,
			// 	path: 'createOrder',
			// 	name: 'createOrder',
			// 	label: '新建订单'
			// },
			{
				id: 3,
				path: 'orderList',
				name: 'orderList',
				label: '全部订单'
			},
			// {
			// 	id: 4,
			// 	path: 'arrivalOrder',
			// 	name: 'arrivalOrder',
			// 	label: '到货订单',
			// 	count: 0
			// },
			{
				id: 6,
				path: 'FBA',
				name: 'FBA',
				label: '批次表'
			},
			{
				id: 8,
				path: 'inStorageOrder',
				name: 'inStorageOrder',
				label: '仓库保管订单',
				count: 0
			},
			{
				id: 7,
				path: 'badOrder',
				name: 'badOrder',
				label: '不良订单',
				count: 0
			},
			/*{
				id: 5,
				path: 'buddleOrder',
				name: 'buddleOrder',
				label: '同捆发货'
			},*/

			{
				id: 9,
				path: 'funding',
				name: 'funding',
				label: '资金明细'
			},
			// {
			// 	id: 10,
			// 	path: 'badList',
			// 	name: 'badList',
			// 	label: '售后反馈'
			// },
			{
				id: 2,
				path: 'recharge',
				name: 'recharge',
				label: '账户充值'
			},
			{
				id: 11,
				path: 'message',
				name: 'message',
				label: '消息提醒'
			},
			{
				id: 12,
				path: 'address',
				name: 'Address',
				label: '地址管理'
			},
			{
				id: 13,
				path: 'defective',
				name: 'defective',
				label: '不良件详情'
			},
			{
				id: 13,
				path: 'laundryLabelTemplate',
				name: 'laundryLabelTemplate',
				label: '水洗标模板管理'
			}
		],
		menuJpList: [
			{
				id: 14,
				path: 'cart',
				name: 'Cart',
				label: '新規注文'
			},
			// {
			// 	id: 1,
			// 	path: 'createOrder',
			// 	name: 'createOrder',
			// 	label: '新規'
			// },
			{
				id: 3,
				path: 'orderList',
				name: 'orderList',
				label: 'すべての注文'
			},
			// {
			// 	id: 4,
			// 	path: 'arrivalOrder',
			// 	name: 'arrivalOrder',
			// 	label: '入荷オーダー',
			// 	count: 0
			// },
			{
				id: 6,
				path: 'FBA',
				name: 'FBA',
				label: '商品出荷指示'
			},
			{
				id: 8,
				path: 'inStorageOrder',
				name: 'inStorageOrder',
				label: '倉庫保管',
				count: 0
			},
			{
				id: 7,
				path: 'badOrder',
				name: 'badOrder',
				label: '不具合注文',
				count: 0
			},
			/*{
				id: 5,
				path: 'buddleOrder',
				name: 'buddleOrder',
				label: '同梱出荷 '
			},*/

			{
				id: 9,
				path: 'funding',
				name: 'funding',
				label: '資金明細'
			},
			// {
			// 	id: 10,
			// 	path: 'badList',
			// 	name: 'badList',
			// 	label: 'フィードバック'
			// },
			{
				id: 2,
				path: 'recharge',
				name: 'recharge',
				label: 'チャージ'
			},
			{
				id: 11,
				path: 'message',
				name: 'message',
				label: 'メッセージ通知'
			},
			{
				id: 12,
				path: 'address',
				name: 'Address',
				label: '住所管理'
			},
			{
				id: 13,
				path: 'defective',
				name: 'defective',
				label: '不良品詳細'
			},
			{
				id: 13,
				path: 'laundryLabelTemplate',
				name: 'laundryLabelTemplate',
				label: '洗濯タグ管理'
			}
		],
		//页面传值
		params: {},
		language: Cookies.get('language') || 'ja-JP'
	},
	// 更改vuex的store中状态的唯一方法 - 同步操作
	mutations: {
		// 跳转页面执行
		selectMenu (state, submenu) {
			// 首页 orderList
			if (submenu.name === 'orderList') {
				submenu.name = 'orderList';
				submenu.path = 'orderList';
			}
			// 当前选中菜单
			var activePath = submenu.path;
			// 历史已选中菜单列表
			var oldTabList = state.tabList;
			// 将菜单信息添加到tablist - 添加时判断是否已有该标签
			var result = oldTabList.some((item) => {
				if (item.path === activePath) {
					return true;
				}
			});
			// console.log("是否在历史已选中菜单列表" + result);
			// 如果不包含该对象，则添加
			if (!result) {
				oldTabList.push({
					path: submenu.path,
					name: submenu.name,
					label: submenu.label
				});
			}
			// 重新赋值
			state.activePath = activePath;
			state.tabList = oldTabList;
			// console.log("activePath activePath activePath" + state.activePath);
		},
		// 添加keepalive缓存
		addKeepAliveCache (state, val) {
			// 添加时判断，如果该组件已存在，则不添加
			if (state.catch_components.indexOf(val) === -1) {
				// 不存在，缓存页面
				if (val !== 'Cart') state.catch_components.push(val);
			}
		},
		// 删除keepalive缓存
		removeKeepAliveCache (state, val) {
			let cache = state.catch_components;
			for (let i = 0; i < cache.length; i++) {
				if (cache[i] === val) {
					cache.splice(i, 1);
				}
			}
			state.catch_components = cache;
		},
		//关闭菜单
		closeTab (state, val) {
			// 重新赋值
			state.activePath = val.activePath;
			state.tabList = val.tabList;
		},
		// 点击标签选择菜单
		changeMenu (state, val) {
			state.activePath = val;
		},
		paramsChanged (state, data) {
			state.params = data;
		},
		setMenus (state, list) {
			state.menuList = list;
		},
		setJpMenus (state, list) {
			state.menuJpList = list;
		}
	},
	// 和mutations类似，异步操作
	actions: {
		async setOrderCount ({ state, commit }) {
			const { data: res } = await $http.get('order/orderTableCount');
			let orderTableData = res.data;
			let menuList = lodash.cloneDeep(state.menuList);
			let menuJpList = lodash.cloneDeep(state.menuJpList);
			// menuList[2].count = orderTableData.arrivalCount;
			menuList[3].count = orderTableData.categoryCount;
			menuList[4].count = orderTableData.badOrderCount;
			// menuJpList[2].count = orderTableData.arrivalCount;
			menuJpList[3].count = orderTableData.categoryCount;
			menuJpList[4].count = orderTableData.badOrderCount;
			commit('setJpMenus', menuJpList);
			commit('setMenus', menuList);
		}
	}
});

export default store;
